"use client";
import { Theme } from "@/shared/constants";
import { useQuery } from "@tanstack/react-query";
import usersApi from "@/api/users/client";
import { redirect } from "next/navigation";
import { Profile } from "../types";
import { ProfileHeader } from "../ProfileHeader";
import { RequestCookie } from "next/dist/compiled/@edge-runtime/cookies";
import { Blockchain } from "@/shared/config/blockchain/types";

export interface Props {
  userId: string;
  profile?: Profile;
  isArtistMe?: boolean;
  isUserFollowing?: boolean;
  isUserLoggedIn?: boolean;
  showProfileOwner?: boolean;
  showProfileVerified?: boolean;
  showProfileAddress?: boolean;
  showArtistRating?: boolean;
  showArtistActions?: boolean;
  theme?: Theme | RequestCookie;
  blockchain: Blockchain;
}

const UserProfileHeader = ({
  userId,
  isUserFollowing,
  isArtistMe,
  isUserLoggedIn,
  showProfileVerified,
  showProfileAddress,
  showArtistRating,
  theme,
  blockchain,
  showArtistActions,
}: Props) => {
  const { data: profile } = useQuery<Profile>({
    queryKey: ["user", userId],
    queryFn: () => usersApi.getUserByIdentifier(userId),
  });

  if (!profile) {
    redirect("/");
  }

  return (
    <ProfileHeader
      profile={profile}
      isArtistMe={isArtistMe}
      isUserFollowing={isUserFollowing}
      isUserLoggedIn={!!isUserLoggedIn}
      showProfileAddress={showProfileAddress}
      showProfileVerified={showProfileVerified}
      showArtistRating={showArtistRating}
      showArtistActions={showArtistActions}
      blockchain={blockchain}
      theme={theme}
    />
  );
};

export default UserProfileHeader;
